jQuery(document).ready(function($) {
	try {
		if (sessionStorage.getItem('infoModalClosed') !== 'true') {
			$('#info-modal').removeClass('hidden');
		}

		$('#close-info-modal').on('click', function() {
			$('#info-modal').addClass('hidden');
			sessionStorage.setItem('infoModalClosed', 'true');
		});
	} catch (e) {
		// *If sessionStorage is not supported the modal will not be shown and an error will not be thrown. This prevents errors if this occurs.
	}
});
